module.exports = __webpack_public_path__ + "img/1474483617.e06977c9.jpg";